import { DefaultTicket } from "@/Components/Index";
import ModalThankyou from "@/Components/Modal/ModalThankYou/ModalThankyou";
import TicketPrint from "@/Components/Ticket/TicketPrint";
import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import useWindowsSize from "@/Hooks/useWindowsSize";
import {
  getIpCliente,
  useDeleteOrderBuy,
  useTicketOrderBuyV2,
} from "@/Service/Api/Index";
//import { serialxd } from "@/Service/SerialImpTerm";
import React, {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);

const stylesd: React.CSSProperties = {
  maxWidth: "233px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const PagePrintTicket = () => {
  const { width } = useWindowsSize();
  const {
    formUserData, //SaveCodeBarra, CodeBarra,
    MBasketMFormData,
  } = useContextTicketProvider();
  const { addTicketProduct, DeleteClearCart } = useTicketCart();
  const { DeleteTaskClearContext } = useContextCheckoutData();
  //
  const { mDatos: mDatosCodeBarra, isLoadingCeckout } = useTicketOrderBuyV2(
    false,
    MBasketMFormData.formData,
    addTicketProduct
  );
  //loading
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //fecha
  const [FechaActual, setFechaActual] = useState<string>("");
  const [graciasView, setGraciasView] = useState<boolean>(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  const timeoutRefThankyou = useRef<number | undefined>(undefined);
  const navigate = useNavigate();
  /*********** basket si se realizo se eliminara ************/
  const { ResponseBasket, ClearDeleteTicket } = useContextTicketProvider();
  const { deleteData, eliminarOrderBuySku } = useDeleteOrderBuy(
    addTicketProduct[0]?.item_id ?? ""
  );

  const TotalSalesPrice = addTicketProduct.reduce((acc, item) => {
    return acc + (item.price ?? 0) * (item.quantity ?? 0);
  }, 0);

  const TotalQuantity = addTicketProduct.reduce((acc, item) => {
    return acc + (item.quantity ?? 0);
  }, 0);

  const nameArticle = addTicketProduct?.map((x) => x.productName)?.join(",");

  let OrderNo = mDatosCodeBarra[0]?.orderResponse?.order_no ?? "";
  let OrderCode = mDatosCodeBarra[0]?.OrderCode ?? "";
  let PrintTitle = formUserData.TypePayment;

  const TimerRef = useCallback(() => {
    timeoutRef.current = window.setTimeout(() => {
      setIsLoading(true);
      handleDateNow();
    }, 2000);
  }, []);

  const TimerRefGracias = useCallback(() => {
    timeoutRefThankyou.current = window.setTimeout(() => {
      setGraciasView(true);
    }, 5000);
  }, []);

  useEffect(() => {
    TimerRef();
    if (!isLoading) {
      //codPrint();
    }
    return () => clearTimeout(timeoutRef.current);
  }, [isLoading, isLoadingCeckout]);

  useEffect(() => {
    TimerRefGracias();
    return () => clearTimeout(timeoutRefThankyou.current);
  }, [graciasView]);

  const handleDateNow = () => {
    const fechasActual = new Date();
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    //nuevo recorrido
    let diasHabiles = 5;
    let contador = 0;
    while (contador < diasHabiles) {
      fechasActual.setDate(fechasActual.getDate() + 1);
      const diasSemana = fechasActual.getDay();
      if (diasSemana !== 0 && diasSemana !== 6) {
        contador++;
      }
    }

    //Acomodar la fecha
    const ano = fechasActual.getFullYear();
    //const mes = String(fechasActual.getMonth() + 1).padStart(2, '0');
    const mes = meses[fechasActual.getMonth()];
    const dia = String(fechasActual.getDate()).padStart(2, "0");

    const fechaSave = `${dia}/${mes}/${ano}`;
    setFechaActual(fechaSave);
  };

  //retirar en domicilio.
  const handdleEnvioDomicilio = [
    {
      nombre: "Iniciar",
      argumentos: [],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["   ¡Gracias por tu compra!\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nArticulo:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [nameArticle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nCantidad: " + TotalQuantity],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nTotal de la orden: $" + TotalSalesPrice],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nNúmero de pedido: " + OrderNo],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nMetodo de entrega:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [PrintTitle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nPresenta este código de barras"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["impreso al pagar en tienda"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "ImprimirCodigoDeBarrasCode128",
      argumentos: ["D387266D", 80, 480, 1], //["D387266D", 80, 380, 0]
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [OrderCode],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nEl código tendrá validez solo"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["por 24 hrs. a partir de esta"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["confirmación\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"], // 5 salto de linea
    },
    {
      nombre: "Corte",
      argumentos: [1],
    },
    {
      nombre: "Iniciar",
      argumentos: [],
    },
  ];

  //enviar a tienda.
  const handdleEntIienda = [
    {
      nombre: "Iniciar",
      argumentos: [],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["   ¡Gracias por tu compra!\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nArticulo:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [nameArticle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nCantidad: " + TotalQuantity],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nTotal de la orden: $" + TotalSalesPrice],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nNúmero de pedido: " + OrderNo],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nMetodo de entrega:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [PrintTitle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nEntrega en:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\nSoriana Híper San Pedro"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nA partir del día:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [FechaActual],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nPresenta este código de barras"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["impreso al pagar en tienda"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "ImprimirCodigoDeBarrasCode128",
      argumentos: ["D387266D", 80, 480, 1],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [OrderCode],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["El código tendrá validez solo"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["por 24 hrs. a partir de esta"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["confirmación\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"], // 5 salto de linea
    },
    {
      nombre: "Corte",
      argumentos: [1],
    },
    {
      nombre: "Iniciar",
      argumentos: [],
    },
  ];

  //print ticket
  const codPrint = async () => {
    const operacionesxd =
      PrintTitle == "Recoger en tienda"
        ? handdleEntIienda
        : handdleEnvioDomicilio;

    //Licencia del plugin para un mes (24/oct/2024 - 23/nov/2024)
    try {
      const cargaUtil = {
        //serial: serialxd,
        serial: "",
        nombreImpresora: "Imp Ticket",
        operaciones: operacionesxd,
      };
      //Usando Plugins de terceros.
      const respuestaHttp = await fetch("http://localhost:8000/imprimir", {
        method: "POST",
        body: JSON.stringify(cargaUtil),
      });
      const respuesta = await respuestaHttp.json();
      if (respuesta.ok) {
        //console.log("Impreso correctamente");
        setGraciasView(true);
      } else {
        console.error(
          "Petición ok pero error en el plugin: " + respuesta.message
        );
      }
    } catch (error) {
      console.log(`[error] : ${error}`);
    }
  };

  const RollBackInit = useCallback(async () => {
    //console.log("Eliminar el basket id del carrito");
    if (
      ResponseBasket?.basketId !== "" ||
      ResponseBasket?.basketId !== undefined
    ) {
      const ipClient = await getIpCliente();
      const deleteBuyOrder = {
        basketId: ResponseBasket?.basketId,
        skuId:
          addTicketProduct
            .flatMap((x) => x.item_id)
            .filter(Boolean)
            .join(",") ?? "",
        ipAddress: ipClient,
      };
      //ENVIAMOS HACIA EL BACK PARA ELIMINAR DESDE CACHE Y LIMPIAR LO DATOS GUARDADOS
      await deleteData(eliminarOrderBuySku, deleteBuyOrder).finally(() => {
        setGraciasView(false);
      });
      if (!graciasView) {
        DeleteClearCart();
        DeleteTaskClearContext();
        ClearDeleteTicket();
        navigate("/");
      }
    }
  }, []);

  return (
    <Suspense>
      <LayoutHomeThree toLink={"/Electrónicav2"} PLP={false}>
        <div className="ps-page--simple">
          <div className="ps-breadcrumb">
            <div className="container">
              <ul className="breadcrumb">
                <li>
                  <Link to="/">Inicio</Link>
                </li>
                <span style={width < 540 ? stylesd : {}}> / Ticket Compra</span>
              </ul>
            </div>
          </div>
          <div className="ps-shopping-cart">
            <div className="container">
              {!isLoading ? (
                <DefaultTicket />
              ) : (
                <div className="mt-2">
                  <TicketPrint
                    //OrderNo={mDatosCodeBarra[0]?.orderResponse?.order_no ?? ""}
                    //OrderCode={mDatosCodeBarra[0]?.OrderCode ?? ""}
                    nameArticle={nameArticle}
                    TotalQuantity={TotalQuantity}
                    TotalSalesPrice={TotalSalesPrice}
                    OrderNo={OrderNo}
                    OrderCode={OrderCode}
                    FechaActual={FechaActual}
                    PrintTitle={PrintTitle}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {graciasView && (
          <ModalThankyou
            showModal={true}
            titleModal={"Gracias"}
            setViewModal={RollBackInit}
          />
        )}
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PagePrintTicket;
